<script>

    import { toast } from 'bulma-toast'
    import { userStore, notificationsStore, modalStore } from '../stores'
    
    import NotificationsService from '../$services/notifications.service'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'

    import Switch from '../$components/switch.svelte'
    import Date from '../$components/date.svelte'

    import Button from '../$components/button.svelte'

    export let type = 'user'

    let data = {view: false, important: false}
    let loading = false

    async function createNotification() {
        
        data.type = type

        if(type == 'user' && $userStore != null)
            data.userId = $userStore._id

        loading = true
        const resp = await NotificationsService.createNotification(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notificationsStore.append(resp.data)
        toast({message: 'Notificación creada', type: 'is-success'})
        modalStore.close()
    }
</script>

<Form on:submit={ createNotification } { loading } >
    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.subject } label="Tema" placeholder="Tema" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.message } label="Mensaje" placeholder="Mensaje" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Switch bind:checked={data.important} label="¿Notificación urgente?" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Date bind:value={data.expired} label="Fecha de expiración" />
        </div>
    </div>
    <div class="items-end space-top">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light" />
            <Button type="submit" text="Agregar" icon="plus" color="primary" { loading } />
        </div>
    </div>
</Form>